module.exports = __webpack_public_path__ + "img/show.5efd5b90.jpg";